import request from '@/plugin/axios'

/**
 * 获取菜单所属模块
 * @returns {Promise<any>}
 */
export function getMenuModule() {
  return new Promise(resolve => {
    resolve({
      admin: '后台',
      home: '前台',
      api: 'API'
    })
  })
}

/**
 * 根据权限获取菜单列表
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getMenuAuthList(data) {
  return request({
    url: '/sys/menu/auth',
    method: 'get',
    data
  })
}

/**
 * 获取菜单列表
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getMenuList() {
  return request({
    url: '/sys/menu/list',
    method: 'get'
  })
}

/**
 * 获取一个菜单
 * @param {Number} menuId
 * @returns {AxiosPromise}
 */
export function getMenuItem(menuId) {
  return request({
    url: '/v1/menu',
    method: 'post',
    params: {
      method: 'get.menu.item'
    },
    data: {
      menuId
    }
  })
}

/**
 * 添加一个菜单
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function addMenuItem(data) {
  return request({
    url: '/sys/menu',
    method: 'post',
    data
  })
}

/**
 * 编辑一个菜单
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function editMenuItem(data) {
  return request({
    url: '/sys/menu',
    method: 'put',
    data
  })
}

/**
 * 根据编号自动设置排序值
 * @param {Array} menuId
 * @returns {AxiosPromise}
 */
export function editMenuIndex(menuId) {
  return request({
    url: '/sys/menu/orderNum',
    method: 'put',
    data: {
      menuId
    }
  })
}

/**
 * 设置菜单状态，同时会影响上级与下级菜单的状态
 * @param {Number} menuId
 * @param {Number} status
 * @returns {AxiosPromise}
 */
export function editMenuStatus(menuId, status) {
  return request({
    url: '/sys/menu/status',
    method: 'post',
    data: {
      menuId,
      status
    }
  })
}
